<template>
  <div class="body">
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="基本信息" name="first">
        <div>
          <table class="table" cellpadding="0" cellspacing="0">
            <tr>
              <td class="tableLabel">单号：</td>
              <td class="tableModel">{{inspectionShipmentVO.billNo}}</td>
              <td class="tableLabel">出厂编号：</td>
              <td class="tableModel">{{inspectionShipmentVO.factoryNo}}</td>
              <td class="tableLabel">客户名称：</td>
              <td class="tableModel">{{inspectionShipmentVO.customerName}}</td>
            </tr>
            <tr>
              <td class="tableLabel">检验员：</td>
              <td class="tableModel">{{inspectionShipmentVO.inspectorName}}</td>
              <td class="tableLabel">检验时间：</td>
              <td class="tableModel">{{inspectionShipmentVO.createdTime}}</td>
              <td class="tableLabel">提交时间：</td>
              <td class="tableModel">{{inspectionShipmentVO.submitTime}}</td>
            </tr>
            <tr>
              <td class="tableLabel">基准：</td>
              <td class="tableModel">{{inspectionShipmentVO.standards}}</td>
              <td class="tableLabel">实际：</td>
              <td class="tableModel">{{inspectionShipmentVO.practical}}</td>
              <td class="tableLabel">问题分类：</td>
              <td class="tableModel">{{inspectionShipmentVO.problemClassification}}</td>
            </tr>
            <tr>
              <td class="tableLabel">物料号：</td>
              <td class="tableModel">{{inspectionShipmentVO.materialNo}}</td>
              <td class="tableLabel">当批总数：</td>
              <td class="tableModel">{{inspectionShipmentVO.batchAllNum}}</td>
              <td class="tableLabel">检查总数：</td>
              <td class="tableModel">{{inspectionShipmentVO.checkAllNum}}</td>
            </tr>
            <tr>
              <td class="tableLabel">实际不良总数：</td>
              <td class="tableModel">{{inspectionShipmentVO.badQuality}}</td>
              <td class="tableLabel">问题初步调查：</td>
              <td class="tableModel">{{inspectionShipmentVO.preliminaryInvestigation}}</td>
              <td class="tableLabel">检验结果：</td>
              <td class="tableModel">{{inspectionShipmentVO.inspectionResult?"通过":"不通过"}}</td>
            </tr>
            <tr>
              <td class="tableLabel" style="color: red">是否改进调查：</td>
              <td class="tableModel">
                <el-radio-group v-model="inspectionShipmentVO.isImprovedSurvey">
                  <el-radio :label="true">是</el-radio>
                  <el-radio :label="false">否</el-radio>
                </el-radio-group>
              </td>
              <td class="tableLabel">责任部门：</td>
              <td class="tableModel">{{inspectionShipmentVO.responsibleDepartment}}</td>
              <td class="tableLabel">部门接口人：</td>
              <td class="tableModel">{{inspectionShipmentVO.responsibleName}}</td>
            </tr>
            <tr>
              <td class="tableLabel">处理人员：</td>
              <td class="tableModel">{{inspectionShipmentVO.handleName}}</td>
              <td class="tableLabel">区域负责工程师：</td>
              <td class="tableModel">{{inspectionShipmentVO.regionalManager}}</td>
            </tr>
          </table>
        </div>
        <div style="padding: 0 0 10px 10px;width: 90%;margin: 0 auto">
          <div>
            <el-form
                ref="formUplosd"
                enctype="multipart/form-data"
                label-position="right"
                label-width="120px"
                size="mini">
              <div style="display: flex;flex-direction: row;align-items: center;justify-content: space-between">
                <div>
                  <div v-if="!inspectionShipmentVO.accessoryList || !inspectionShipmentVO.accessoryList.length">暂无附件</div>
                  <table width="100%">
                    <tr v-for="(item, index) in inspectionShipmentVO.accessoryList" :key="index">
                      <td>附件{{index + 1}}</td>
                      <td style="cursor: pointer;padding:5px;color: #20a0ff" @click="openFile(item)">{{item.fileName}}</td>
                      <td style="padding:5px"><el-input v-model="item.note" size="mini"/></td>
                      <td style="padding:5px;color: #20a0ff;cursor: pointer;" @click="deleteFile(index)">删除</td>
                    </tr>
                  </table>
                </div>
                <div>
                  <el-upload
                      action=""
                      multiple
                      :http-request="submitUpload"
                      :show-file-list="false"
                      :disabled="uploadLoading"
                      style="display: inline-block; float: right; margin: 5px;">
                    <el-button type="primary" plain>
                      <i class="el-icon-upload el-icon--right"/>
                      附件上传
                    </el-button>
                  </el-upload>
                </div>
              </div>
            </el-form>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="工作流详情" name="fourth">
        <handle-detail :bill-id="billId" :bill-type="billType" :sequ-id="sequId"/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
  import HandleDetail from "@/views/workFlow/HandleDetail";
  import constants from "@/util/constants";
  import loginUtil from "@/util/loginUtil";

  export default {
    name: "InspectionShipmentPreview",
    components: {HandleDetail},
    props: {
      billId: {
        type: String,
        required: true,
      },
      billType: {
        type: String,
        required: true,
      },
      sequId: {
        type: String,
        required: true,
      },
      params: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        constants,
        activeName: "first",
        uploadLoading: false,
        dealWayLiat: [],
        inspectionShipmentVO: {
          accessoryList: [],
        },

      };
    },
    watch: {
      params: {
        handler() {
          this.doApprove();
        },
      },
    },
    mounted() {
      this.getData();
    },
    methods: {
      getData() {
        this.$emit("loading-status", {"loading": true});
        this.$http
          .get("basic", `inspectionShipments/${this.billId}`)
          .then(resp => {
            this.$emit("loading-status", {"loading": false});
            this.inspectionShipmentVO = resp;
            console.log(this.inspectionShipmentVO);
          });
      },
      submitUpload(params) {
        this.uploadLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("files", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http
          .post("basic", "file/batch/0", formData)
          .then((res) => {
            this.uploadLoading = false;
            // this.saveAttachments(res.data.attachments, 0);
            const fileInfo = res.data.attachments[0];
            console.log(fileInfo);
            this.inspectionShipmentVO.accessoryList.push({
              fileName: fileInfo.fileName,
              filePath: "/attached/file/" + fileInfo.filePath,
              note: "",
            });
            this.$message.success("上传成功");
          })
          .catch(() => {
            this.uploadLoading = false;
            this.$message.error("上传失败");
          });
      },
      onSelectHandle(row) {
        this.inspectionShipmentVO.handleID = row.systemUserID;
        this.inspectionShipmentVO.handleName = row.employeeName;
      },
      onSelectCountersign(row) {
        this.inspectionShipmentVO.countersignID = row.systemUserID;
        this.inspectionShipmentVO.countersignName = row.employeeName;
      },
      onSelectRework(row) {
        this.inspectionShipmentVO.reworkID = row.systemUserID;
        this.inspectionShipmentVO.reworkName = row.employeeName;
      },
      deleteFile(index) {
        this.inspectionShipmentVO.accessoryList.splice(index, 1);
      },
      openFile(item) {
        console.log(item);
        let a = document.createElement("a");
        a.href = "https://emes.stepelectric.com" + item.filePath;
        a.target = "_blank";
        a.download = item.filePath;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
      },
      saveEntity() {
        this.$http
          .put("basic", "inspectionShipments/updateEntity", this.inspectionShipmentVO)
          .then(() => {
          });
      },
      doApprove() {
        if (this.params.actionType === 0) {
          this.inspectionShipmentVO.nodeId =this.params.nodeId;
          if (this.params.nodeId === "DealDepartment") {
            this.inspectionShipmentVO.processMode = this.params.applicationVarVOS[0].varValue;
            console.log(this.inspectionShipmentVO.processMode);
            this.saveEntity();
            //企业微信通知;
            if (this.params.applicationVarVOS[0].varValue === "特批" && this.params.applicationVarVOS[1].varValue === "true") {
              this.params.applicationVarVOS.forEach(item=>{
                if (item.varValue === "true" && item.varName === "CountersignComments_ht") {
                  this.sentWeChat(0,"wangtj");
                  setTimeout(1000);
                }else if (item.varValue === "true" && item.varName === "CountersignComments_ds") {
                  this.sentWeChat(0,"liuyf");
                  setTimeout(1000);
                }else if (item.varValue === "true" && item.varName === "CountersignComments_bs") {
                  this.sentWeChat(0,"yuyong");
                  setTimeout(1000);
                }else if (item.varValue === "true" && item.varName === "CountersignComments_cg") {
                  this.sentWeChat(0,"liuym");
                  setTimeout(1000);
                }else if (item.varValue === "true" && item.varName === "CountersignComments_clg") {
                  this.sentWeChat(0,"cailg");
                  setTimeout(1000);
                }
              });
            }
          }else if (this.params.nodeId === "EngineerConfirmed") {
            if (this.inspectionShipmentVO.isImprovedSurvey == null) {
              return this.$message.error("请填写是否需要改进！");
            }
            this.saveEntity();
          }
          if (this.params.nodeId === "Rework") {
            this.inspectionShipmentVO.inspectionResult = true;
            this.saveEntity();
          }
          
          
        }
        let params = {
          billId: parseInt(this.billId),
          billType: parseInt(this.billType),
          sequId: parseInt(this.sequId),
          actionType: this.params.actionType,
          approveNote: this.params.approveNote,
          untreadedFlowId: this.params.untreadedFlowId,
          approveVar: this.params.approveVar,
          billParam: "",
        };
        console.log(this.params.applicationVarVOS);
        this.$emit("loading-status", {"loading": true});
        this.$http
          .post("basic", "applications/doApprove", params)
          .then(() => {
            this.$emit("loading-status", {"loading": false});
            //退回到审批人时状态修改到未提交
            if (this.params.actionType ===2 && this.params.untreadedFlowId === "0;submitter") {
              this.updateinspectionShipmentVOStatus();
            }
            this.$message.success("操作成功");
            // 关闭标签
            this.$bus.$emit("closeTag", this.$route);
            this.$router.push({
              path: "/workFlow/InspectionShipment",
            });
          }).catch(() => {
            this.$emit("loading-status", {"loading": false});
          });
      },
      sentWeChat(userId,name) {
        let params = {
          userId:userId,
          name:name,
          pkid:this.inspectionShipmentVO.pkid,
          formId:29,
        };
        this.$http
          .get("basic", "inspectionInComings/sentWeChat",params)
          .then(() => {
          });
      },
      updateinspectionShipmentVOStatus() {
        this.$http
          .get("basic", `inspectionShipmentVOs/updateinspectionShipmentVOStatus/${this.inspectionShipmentVO.pkid}`)
          .then(() => {
            this.$message.success("退回到提交人成功！！！");
          });
      },
    },
  };
</script>
<style lang="scss">
  .body {
    .table {
      width: 100%;
      margin: 2% auto;
      border-top: 1px solid #dddddd;
      border-left: 1px solid #dddddd;

      .tableLabel {
        width: 130px;
        padding: 1%;
        background: #f4f7fa;
        border-bottom: 1px solid #dddddd;
      }

      .tableModel {
        width: 20%;
        padding: 1%;
        border-left: 1px solid #dddddd;
        border-right: 1px solid #dddddd;
        border-bottom: 1px solid #dddddd;
      }
    }
  }
</style>
